export default function Fractures() {
  return <h1>Fractures</h1>;
}
